import type {UpdateResourceStatusSchema} from '@cypro/engine/mutators'
import {useUpdateTradeNameStatus} from '@/modules/products/trade-names/api'
import {useCan} from '@/shared/hooks/use-permissions'
import {ResourceDrawerSummary} from '@/shared/components/ui/resource-drawer-summary'
import {useTradeNameContext} from '@/shared/contexts/trade-name'
import {useTranslate} from '@tolgee/react'
import {LuPillBottle} from 'react-icons/lu'

export function TradeNameSummary() {
  const {t} = useTranslate('common')
  const {tradeName} = useTradeNameContext()
  const updateStatus = useUpdateTradeNameStatus()
  const canManageCatalogue = useCan('catalogue.manage')

  const description: string[] = []
  if (tradeName.medicationProfile?.drugCatalogItem?.catalogType) {
    description.push(t(tradeName.medicationProfile.drugCatalogItem.catalogType))
  }
  if (tradeName.containerType?.name) {
    description.push(tradeName.containerType.name)
  }

  return (
    <ResourceDrawerSummary
      title={tradeName.name}
      description={description.join(' • ')}
      icon={LuPillBottle}
      status={tradeName.status}
      {...(canManageCatalogue
        ? {onChangeStatus: (status: UpdateResourceStatusSchema['status']) => updateStatus({id: tradeName.id, status})}
        : {})}
    />
  )
}
